import React, { useState, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { inpS, btnP, crd } from "../../constants/styles";
import Fld from "../common/Fld";

function CCFormPage() {
  const { t, h, ccs, setCcs, tens, props, pays, setPays, go, flash, editingCC, setEditingCC } = useContext(Ctx);
  const defaultItems = [{ name: t.eb, amount: "" }, { name: t.cleaning, amount: "" }];
  const [items, setItems] = useState(editingCC && editingCC.items && editingCC.items.length > 0 ? editingCC.items : (editingCC ? [{ name: t.eb, amount: editingCC.eb }, { name: t.cleaning, amount: editingCC.cl }] : defaultItems));
  const [selPropId, setSelPropId] = useState(editingCC?.property_id || "");

  // Count active tenants — filtered by selected property if any
  const activeTenants = tens.filter(te => !te.vac && te.pid && props.find(p => p.id === te.pid) && (!selPropId || te.pid === selPropId));
  const act = activeTenants.length || 1;
  const tot = items.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);

  // Copy from last month
  const copyLastMonth = () => {
    const sorted = [...ccs].sort((a, b) => (b.id || "").localeCompare(a.id || ""));
    const last = sorted[0];
    if (last && last.items && last.items.length > 0) {
      setItems(last.items.map(it => ({ name: it.name, amount: it.amount })));
      if (last.property_id) setSelPropId(last.property_id);
      flash(t.copied || "Copied from last month!");
    } else {
      flash(t.noPrev || "No previous charges found", "error");
    }
  };

  const addItem = () => setItems([...items, { name: "", amount: "" }]);
  const updateItem = (i, field, val) => {
    const list = [...items]; list[i][field] = val; setItems(list);
  };
  const removeItem = (i) => setItems(items.filter((_, idx) => idx !== i));

  return <div style={{ paddingTop: 16 }}><button onClick={() => { setEditingCC(null); go("cc"); }} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
    <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{editingCC ? t.editCC : t.common}</h2>
    <div style={{ ...crd(h), padding: 20 }}>
      {/* Property selection */}
      <div style={{ marginBottom: 16 }}>
        <label style={{ color: h.ts, fontSize: 12, fontWeight: 600, display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.3 }}>{t.selectProp || "Property"}</label>
        <select value={selPropId} onChange={e => setSelPropId(e.target.value)} style={{ ...inpS(h), width: "100%" }}>
          <option value="">{t.allProps || "All Properties"}</option>
          {props.map(p => <option key={p.id} value={p.id}>{p.addr}</option>)}
        </select>
        <div style={{ color: h.ts, fontSize: 11, marginTop: 4 }}>{act} {t.active || "active"} {t.tenants || "tenants"}{selPropId ? ` in ${props.find(p => p.id === selPropId)?.addr || "property"}` : ""}</div>
      </div>

      {/* Copy from last month */}
      {!editingCC && ccs.length > 0 && <button onClick={copyLastMonth} style={{ width: "100%", padding: 10, borderRadius: 10, border: `1px solid ${h.ac}`, background: `${h.ac}08`, color: h.ac, fontSize: 12, fontWeight: 600, cursor: "pointer", marginBottom: 16 }}>{"\uD83D\uDCCB"} {t.copyLast || "Copy from Last Month"}</button>}

      {items.map((it, i) => (
        <div key={i} style={{ display: "flex", gap: 8, marginBottom: 12, alignItems: "center" }}>
          <div style={{ flex: 2 }}>
            <Fld l={t.svcName} v={it.name} set={(v) => updateItem(i, "name", v)} h={h} ph="e.g. EB Bill" mb={0} />
          </div>
          <div style={{ flex: 1 }}>
            <Fld l={t.amount} v={it.amount} set={(v) => updateItem(i, "amount", v)} h={h} type="number" ph="₹0" mb={0} />
          </div>
          {items.length > 1 && <button onClick={() => removeItem(i)} style={{ padding: "8px", background: `${h.rd}20`, color: h.rd, border: "none", borderRadius: 8, cursor: "pointer", height: 42, marginTop: 18 }}>✕</button>}
        </div>
      ))}
      <button onClick={addItem} style={{ width: "100%", padding: 12, borderRadius: 10, border: `1px dashed ${h.ac}`, background: "transparent", color: h.ac, fontSize: 12, fontWeight: 600, cursor: "pointer", marginBottom: 16 }}>{t.addAnotherSvc}</button>

      {tot > 0 && <div style={{ background: `${h.ac}10`, borderRadius: 10, padding: 12, marginBottom: 16 }}>
        <div style={{ color: h.sc, fontSize: 12 }}>{t.total}: ₹{tot.toLocaleString()} · {t.split} {act} {t.active}</div>
        <div style={{ color: h.ac, fontWeight: 700, fontSize: 16, marginTop: 4 }}>{t.perTen}: ₹{Math.round(tot / act).toLocaleString()}</div></div>}
      <button onClick={() => {
        if (tot === 0) return;
        const d = new Date();
        const mNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const moStr = `${mNames[d.getMonth()]} ${d.getFullYear().toString().slice(-2)}`;

        // IMPORTANT FOR BACKWARD COMPATIBILITY: Send tot as eb so old server computes split correctly.
        const newCC = {
          id: editingCC ? editingCC.id : `c${Date.now()}`,
          mo: editingCC ? editingCC.mo : moStr,
          eb: tot, cl: 0, n: act, items,
          property_id: selPropId || null
        };

        const splitAmt = Math.round(tot / act);
        const up = pays.map(p => (p.mo === newCC.mo && p.st === "due") ? { ...p, com: splitAmt } : p);
        if (editingCC) setCcs(ccs.map(c => c.id === editingCC.id ? newCC : c)); else setCcs([...ccs, newCC]);
        setPays(up);
        // Explicitly force the live backend to save these split payments
        // Only for tenants in the selected property (or all if no property selected)
        const targetTenantIds = activeTenants.map(te => te.id);
        up.forEach(p => {
          if (targetTenantIds.includes(p.tid) && p.mo === newCC.mo && p.st === "due") {
            api.savePayment(p);
          }
        });

        api.saveCC(newCC);
        setEditingCC(null);
        flash(editingCC ? t.updated : t.added); go("cc");
      }} style={btnP(h)}>{t.save}</button>
    </div></div>;
}

export default CCFormPage;
